import axios from 'axios'
var qs = require("querystring")
export default {
  state:{
    work_type_List:'',
    business_type_List:'',
    workstate_type_List:'',
    accumulationFundList:[],
    socialInsuranceList:[],

  },
  mutations:{
    findwork_typelist(state,data){
      state.work_type_List=data
    },
    findAccumulationFund(state,data){
      state.accumulationFundList=data
    },
    findSocialInsurance(state,data){
      state.socialInsuranceList=data
    }

  },
  actions:{
    findwork_typelist(context){
      if(context.state.work_type_List==''){
        axios.post('home/allFindDropDownListByTableNameAndFieldName',{'table_name':'STAFF_STATE_HIS','field_name':'work_type'}).then(res=>{
          // context.state.work_type_List=res.data;
          context.commit('findwork_typelist',res.data)
        })
      }
    },//查找用工性质

    findbusiness_typelist(context){
      axios.post('home/allFindDropDownListByTableNameAndFieldName',{'table_name':'ALL_TABLE','field_name':'business_type'}).then(res=>{
        context.state.business_type_List=res.data;
      })

    },//查找业务性质

    findwork_statelist(context){
      axios.post('home/allFindDropDownListByTableNameAndFieldName',{'table_name':'STAFF_INFO','field_name':'work_state'}).then(res=>{
        context.state.workstate_type_List=res.data;
      })

    },//查找用工性质

    findAccumulationFund(context){
      if(context.state.accumulationFundList==''){
        axios.post('home/findStaffAccumulationFund').then(res=>{
          context.commit('findAccumulationFund',res.data.message)
        })
      }


    },//查找公积金
    findSocialInsurance(context){
      if(context.state.socialInsuranceList=='') {
        axios.post( 'home/findStaffSocialInsurance').then(res => {
          context.commit('findSocialInsurance', res.data.message)
        })
      }
    }//查找社保

  }
}



// WEBPACK FOOTER //
// ./src/vuex/findDropDownListModule.js